import './avatar.css';
export default {
  "avatar": "pf-v6-c-avatar",
  "modifiers": {
    "bordered": "pf-m-bordered",
    "sm": "pf-m-sm",
    "md": "pf-m-md",
    "lg": "pf-m-lg",
    "xl": "pf-m-xl"
  }
};